module.exports = __webpack_public_path__ + "media/images/faces/face16-dd1c48feaa1330af6a60590a26f5b6b4.jpg";